import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

// before decimal allow only three digit and after that only two digit
export const formatAmount = (value) => {
  if (value === '.') {
    return '';
  }

  const valueParts = value.toString().split('.');

  if (valueParts.length > 2) {
    let updatedValePartOne = valueParts[0];
    valueParts[0].length > 3
      ? (updatedValePartOne = valueParts[0].substring(0, valueParts[0].length - 1))
      : updatedValePartOne;
    return updatedValePartOne;
  } else if (valueParts.length < 2) {
    valueParts[0].length > 4 ? (valueParts[0] = valueParts[0].substring(0, valueParts[0].length - 1)) : valueParts[0];
    return valueParts[0];
  }

  let partOne =
    valueParts[0].length > 4 ? (valueParts[0] = valueParts[0].substring(0, valueParts[0].length - 1)) : valueParts[0];

  let partTwo =
    valueParts[1].length > 2 ? (valueParts[1] = valueParts[1].substring(0, valueParts[1].length - 1)) : valueParts[1];

  return partOne + '.' + partTwo;
};

//removing the trailing dot from string
export const removeTrailingDot = (str) => {
  return str.replace(/\.$/, '');
};

//removing the leading zero
export const removeLeadingZero = (str, excludeChars = '') => {
  // Escape special characters in excludeChars
  let escaped = excludeChars.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');

  // Build dynamic negative lookahead regex
  let regex = new RegExp(`^0+(?![${escaped}])`);

  let result = str.replace(regex, '');
  return result === '' ? '0' : result;
};
export const allowOnlyASCIICharacter = (event, handleChange) => {
  const sanitizedValue = event?.target.value.replace(/[\x00-\x1F]/g, '');
  event.target.value = sanitizedValue;
  handleChange(event);
};

export const handleNavigate = ({ item, isFrom }) => {
  let keyCloakLoginToken = localStorage?.getItem('keyCloakLoginToken');
  let url;
  if (item) {
    url = `${
      process.env.REACT_APP_CLAIMS_URL
    }/claim/edit/${item}?access_token=${keyCloakLoginToken ? keyCloakLoginToken : ''}`;
  } else {
    url = `${process.env.REACT_APP_CLAIMS_URL}/dashboard?access_token=${keyCloakLoginToken ? keyCloakLoginToken : ''}`;
  }

  return (
    <Link
      to={isFrom === 'txnId' ? url : `/OrderDetails/${item}`}
      target={isFrom === 'txnId' ? '_blank' : null}
      style={{ color: '#02A0FC', textDecoration: 'none' }}
      onMouseEnter={(e) => (e.target.style.textDecoration = 'underline')}
      onMouseLeave={(e) => (e.target.style.textDecoration = 'none')}
    >
      <Typography sx={{ width: '6rem' }}>{item}</Typography>
    </Link>
  );
};
export const handleSetInputData = (e) => {
  let value;
  value = e.target.value
    .replace(/[^0-9.]/g, '') // removes everything from the string except numbers and dots
    .replace(/(\..*?)\..*/g, '$1') // removing everything after the second dot
    .replace(/^(\d+\.?\d{0,2}).*$/, '$1');

  // value = formatAmount(value);
  return value;
};
export const handleUserRoleFromToken = () => {
  let tokenDecodeData;
  const token = localStorage.getItem('loginToken');
  if (token) {
    try {
      const decoded = jwtDecode(token);
      tokenDecodeData = decoded;
    } catch (error) {
      tokenDecodeData = '';
    }
  }
  return tokenDecodeData;
};

export const allowOnlyNumberWithSingleDot = (value) => {
  if (!value) return value;

  let sanitized = value.replace(/-/g, '');
  sanitized = sanitized.replace(/[^0-9.]/g, '');
  const parts = sanitized.split('.');
  if (parts.length > 2) {
    sanitized = parts[0] + '.' + parts.slice(1).join('');
  }

  return sanitized;
};

export const compareString = (value1, value2) => {
  
  return String(value1 ?? "")
    .toUpperCase()
    === String(value2 ?? "")
    .toUpperCase();
};
